module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (243).04c1ec57.jpg";